import React, { useContext } from "react";
import axios from "axios";

import { settings } from "../Services/apiSetting";

import {
  generatePayload,
  encryptPassword,
} from "../Components/Common/generatePayload";

const { apiUrl, user } = settings;

export default class userServices {
  static async register(params) {
    try {
      params.password = encryptPassword(params.emailAddress);

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      };

      return await axios.post(
        apiUrl,
        generatePayload(params, user.register),
        config
      );
    } catch (err) {
      throw err;
    }
  }

  static async requestOTP(params) {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      };

      return await axios.post(
        apiUrl,
        generatePayload(params, user.requestOTP),
        config
      );
    } catch (err) {
      throw err;
    }
  }

  static async login(data) {
    try {
      const params = {
        ...data,
        otpCode: data.otpCode,
      };

      // console.log("params", params);

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      };

      return await axios.post(
        apiUrl,
        generatePayload(params, user.login),
        config
      );
    } catch (err) {
      throw err;
    }
  }

  static async logout() {
    try {
      const params = {
        uniqueKey: localStorage.getItem("uniqueKey"),
      };

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      };

      return await axios.post(
        apiUrl,
        generatePayload(params, user.logout),
        config
      );
    } catch (err) {
      throw err;
    }
  }

  static async getProfileDetails(skip, take) {
    try {
      const params = {
        uniqueKey: localStorage.getItem("uniqueKey"),
        skip,
        take,
      };

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      };

      return await axios.post(
        apiUrl,
        generatePayload(params, user.getProfileDetails),
        config
      );
    } catch (err) {
      throw err;
    }
  }

  static async requestQuotation(data) {
    try {
      const params = {
        uniqueKey: localStorage.getItem("uniqueKey"),
        ...data,
      };

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const response = await axios.post(
        apiUrl,
        generatePayload(params, user.requestQuotation),
        config
      );

      return response;
    } catch (err) {
      throw err;
    }
  }
}
